enum CardPhases {
  DRAW_INTRO = 'DRAW_INTRO',
  DRAW_ACTIVE = 'DRAW_ACTIVE',
  DRAW_OUTRO = 'DRAW_OUTRO',

  PLAY_INTRO = 'PLAY_INTRO',
  PLAY_ACTIVE = 'PLAY_ACTIVE',
  PLAY_OUTRO = 'PLAY_OUTRO',

  CHANGE_INTRO = 'CHANGE_INTRO',
  CHANGE_ACTIVE = 'CHANGE_ACTIVE',
  CHANGE_OUTRO = 'CHANGE_OUTRO',

  DISCARD = 'DISCARD',

  FINISHED = 'FINISHED',
}

export const cardPhaseKeys = Object.keys(CardPhases) as CardPhases[];

enum SegmentTypes {
  EXERCISE = 'EXERCISE',
  REST = 'REST',
  WARM_UP = 'WARM_UP',
  COOL_DOWN = 'COOL_DOWN',
  RECOVER_STRETCH = 'RECOVER_STRETCH',
  CHAPTERED_ACTIVITY = 'CHAPTERED_ACTIVITY',
}

enum GuidedPhases {
  IDLE = 'IDLE',
  DOWNLOADING = 'DOWNLOADING',
  READY = 'READY',
  PLAYING = 'PLAYING',
  FINISHED = 'FINISHED',
}

// Domain types (Workout, WorkoutSegment, SegmentInfo, GuidedWorkout, etc.)
// are now defined as MST models in @/stores/models/.

// ─── Raw API response types ─────────────────────────────────────
export type ApiSegmentChapter = {
  id: number;
  total_progress_time_ms: number | null;
  segment_chapter_info: {
    id: number;
    unique_name: string;
    title: string;
    description: string | null;
    start_time_ms: number;
    end_time_ms: number;
  };
};

export type ApiSegment = {
  id: number;
  segment_info: string; // unique_name for remote config lookup
  repetitions: number | null;
  completion_time: number; // seconds
  group: string;
  has_skipped: boolean;
  started_at: number | null;
  completed_at: number | null;
  resumed_at: number | null;
  current_user_chapter_id?: number | null;
  user_segment_chapters?: ApiSegmentChapter[];
};

export type ApiWorkout = {
  id: number;
  workout_id: number;
  segments: ApiSegment[];
  started_at: number | null;
  completed_at: number | null;
  workout_template_type?: string;
};

export type ApiCreateWorkoutResponse = {
  success: boolean;
  data: { workout: ApiWorkout };
  error: string | null;
};

// ─── Remote config types ────────────────────────────────────────
export type RemoteConfigFile = {
  collection_name: 'videos' | 'audios';
  order: number;
  url: string;
  hash: string;
  /** File size in bytes (used for pre-download disk-space checks) */
  size: number;
};

export type RemoteConfigEquipment = {
  id: number;
  name: string;
  unique_name: string;
};

export type RemoteConfigSegment = {
  unique_name: string;
  name: string;
  segment_type: string;
  preview_time: number | null;
  files: RemoteConfigFile[];
  equipment: RemoteConfigEquipment[];
};

export type RemoteConfigData = {
  segments: Record<string, RemoteConfigSegment>;
};

// ─── Create workout payload ─────────────────────────────────────
export type CreateWorkoutPayload = {
  workout_id: number | null;
  fitness_level: string;
  workout_template_type: string;
  focus_areas: string[] | null;
  year: number;
  week: number;
  day: number;
  useMlWorkout: boolean;
  path_id: number | null;
  order: number | null;
};

export { CardPhases, SegmentTypes, GuidedPhases };
